import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Metodo para visualizar las etiquetas agendadas del usuario
 *
 * @param {*} { commit}
 */
export async function descargarEtiquetasMasivo({commit, state}, id) {
    await $http.post(`empresas/procesamientos_background/ETIQUETAS-MASIVO/${id}`)
        .then((response) => {
            commit('setEtiquetasArchivo', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = true;
        });
}

/**
 * Metodo para visualizar las etiquetas agendadas del usuario
 *
 * @param {*} { commit}
 */
export async function listarEtiquetasAgendadas({commit}, {id_empresa, tipo_proceso}) {
    await $http.get(`empresas/procesamientos_background/${tipo_proceso}/${id_empresa}`)
        .then((response) => {
            commit('setEtiquetasAgendadas', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Metodo para generar etiquetas en PDF
 *
 * @export
 * @param {*} { commit, state, rootState }
 * @param {*} id
 * @returns
 */
export async function generarEtiquetaPDF({commit, state, rootState}, id) {

    var producto = rootState.productos.selectedProduct.id;
    if (!producto) producto = id;

    commit('dashboard/load', true, {root: true});
    await $http.post(`adm_productos/etiqueta/${producto}`, state.pdfet)
        .then((response) => {
            commit('dashboard/load', false, {root: true});

            let url = response.data;
            if (response.data.advertencia) {
                commit('setAdvertenciaEtMultiple', response.data.message);
                url = response.data.data;
            } else {
                commit('setAdvertenciaEtMultiple', '');
            }
            commit('etiquetaLink', process.env.VUE_APP_API_URL + url);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('etiquetaError', error.message);
        });
}

/**
 * Metodo para generar etiquetas en Word
 *
 * @export
 * @param {*} { commit, state, rootState }
 * @param {*} id
 * @returns
 * @author Santiago Echeverri
 */
export async function generarEtiquetaWord({commit, state, rootState}, id) {

    let producto = rootState.productos.selectedProduct.id;
    const productoNombre = rootState.productos.selectedProduct.nombre;
    if (!producto) {
        producto = id;
    }
    commit('dashboard/load', true, {root: true});
    await $http.post(`adm_productos/etiqueta_word/${producto}`, state.pdfet, {
        responseType: 'blob'
    })
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            let advertencia = await new Response(response.data).text();
            if (advertencia.length < 300) {
                advertencia = JSON.parse(advertencia);
                let url = advertencia.data;
                commit('setAdvertenciaEtMultiple', advertencia.message);
                commit('etiquetaLink', process.env.VUE_APP_API_URL + url);
            } else {
                commit('setAdvertenciaEtMultiple', '');
                window.downloadFile(response.data, productoNombre + '.docx')
            }
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            let res = await new Response(error).text();
            const err = JSON.parse(res);

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: err.message + '<br>' + err.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('etiquetaError', error.message);
        });
}

/**
 *  Método para descarga masiva de etiquetas
 *
 * @export
 * @param {*} { commit, state, rootState }
 * @returns
 * @author Santiago Echeverri
 */
export async function agendarEtiquetas({commit, state}, {tipo_proceso,pdfet}) {
    pdfet.uuid = state.pdfet.uuid
    await $http.post(`empresas/procesamientos_background/${tipo_proceso}`, pdfet)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 6000
            });
            commit('setError', false);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('setError', true);
        });
}

/**
 * Método que lista las empresas registradas en el sistema.
 *
 * @param {*} param0
 */
export async function listarEmpresas({state, commit}) {

    await $http.get('/empresas')
        .then((response) => {

            commit('cargarEmpresas', response.data.data.data);
        })
        .catch((error) => {

        });
}

/**
 * Validar asignación de un producto a una empresa
 * @param id_producto Contiene el id del producto a validar.
 * @param id_empresa Contiene el id de la empresa a validar.
 * @returns {Promise<boolean>} Contiene un booleano.
 * @author Jhon García
 */
export async function validarAsignacion({commit}, {id_producto, id_empresa}) {
    return await new Promise(async (resolve) => {
        commit('dashboard/load', true, {root: true});
        await $http.get(`adm_productos/validar-asignacion/${id_producto}/${id_empresa}`)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                const asignado = response.data.asignado;
                if (!asignado) {
                    commit('dashboard/load', false, {root: true});
                    commit('establecerAsignada', false);
                    await Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Producto no asignado',
                        text: 'El producto no se encuentra asignado a la empresa seleccionada, por lo que la etiqueta se generará sin la fecha del FDS.',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Continuar',
                        cancelButtonText: 'Cancelar'
                    })
                        .then(result => resolve(result.isConfirmed))
                        .catch(() => resolve(false));
                } else {
                    commit('establecerAsignada', true);
                }
                resolve(true);
            }).catch(async () => {
                commit('dashboard/load', false, {root: true});
                resolve(false);
            });
    });
}

export async function obtenerEmpresas({dispatch, commit, state}, nombre) {

    if (!state.cargando_datos_select && nombre && nombre.length > 2) {
        commit('establecerCargandoDatosSelect', true);

        let parametros = {
            params: {
                nombre: nombre,
                info_etiquetas: 1
            }
        };

        commit('dashboard/load', true, {root: true});

        await $http.get('/empresas/lista', parametros)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCargandoDatosSelect', false);
                commit('establecerEmpresas', response.data.data);
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
                console.warn('No se encontraron empresas con el nombre especificado');
                commit('establecerCargandoDatosSelect', false);
            });
    }
}

/**
 * Descargar las etiquetas por producto.
 *
 * @param {*} params: parametros (prodictId: id del producto, refs: referencias de Vue)
 *
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function downloadLabelsByProduct({ commit, state, rootState }, params) {

    const producto = rootState.productos.selectedProduct.id;
    if (!producto) producto = params.id;

    commit('dashboard/load', true, { root: true });
    await $http.post(`/products/download-labels/${producto}`, state.dataLabelsBaker)
        .then(({ data: response }) => {

            if (response.responseCode == 'ET-MICRO-INSUFFICIENT-SPACE') {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Alerta',
                    text: response.message,
                    showConfirmButton: true,
                })
            } else if (response.responseCode == 200) {
                // crear url dinamica para poder
                const endPointPDF = window.URL.createObjectURL(convertBase64FiletoBlob(response.fileBase64));

                // previsualizar el pdf
                commit('etiquetaLink', endPointPDF);

                params.refs.modal_cas.show();
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Alerta',
                    text: response.message,
                    showConfirmButton: true,
                })
            }

        })
        .catch((error) => commit('etiquetaError', error.message))
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Convertir datos del pdf obtenido en base64 a tipo Blob.
 *
 * @param {*} fileBase64: archivo en base 64 que se quiere formatear y devolver en Blob
 * @param {*} contentType: tipo de contenido, ejemplo: 'application/pdf'
 * @returns string
 * @author Fernando Claros
 */
function convertBase64FiletoBlob(fileBase64, contentType = 'application/pdf; application/octet-stream') {

    //application/octet-stream
    const byteArray = Uint8Array.from(window.atob(fileBase64).split('').map(char => char.charCodeAt(0)));

    return new Blob([byteArray], {
        type: contentType
    });
}
